<template>
  <div class="container ">
    <div class="row">
      <div class="col-8 offset-2">
        <!-- Material form login -->
        <div class="card" v-if="submitted == false">

          <h5 class="card-header info-color white-text text-center py-4">
            <strong>{{$t('Passwort.Passwortvergessen')}}</strong>
          </h5>

          <!--Card content-->
          <div class="card-body px-lg-5 pt-0">

            <!-- Form -->
            <form class="text-center" style="color: #757575;"  @submit.prevent="test">

              <!-- Email -->
              <div class="md-form">
                <mdb-input v-model="username" label="Email"></mdb-input>
              </div>

              <!-- Sign in button -->
              <mdb-btn color="primary"  v-on:click="reset">{{$t('Passwort.Passwortzurueck')}}</mdb-btn>

            </form>
            <!-- Form -->

          </div>

        </div>
        <div class="card" v-else>

          <h5 class="card-header info-color white-text text-center py-4">
            <strong>{{$t('Passwort.Passwortvergessen')}}</strong>
          </h5>

          <!--Card content-->
          <div class="card-body px-lg-5">

              <!-- Email -->
              <h3 class="text-center">Eine E-Mail wurde an Ihre Email-Adresse geschickt, folgen Sie den darin enthaltenen Anweisungen.</h3>
            <router-link :to="{ name: 'home' }" class="navbar-brand">
              <div class="btn btn-outline-danger">Zum Login</div>
            </router-link>


            <!-- Form -->

          </div>

        </div>
        <!-- Material form login -->
      </div>
    </div>
  </div>

</template>

<script>
import mapActions from 'vuex'
import userService from "@/services/UserService";
import EmailService from "@/services/EmailService";
import { mdbBtn, mdbInput, mdbDatePicker, mdbSelect, mdbSelectOption } from 'mdbvue';
export default {
  name: "Reset",
  components: {
    userService,
    mdbBtn,
    mdbInput
  },
  data () {
    return {
      username: '',
      submitted: false,
    }
  },
  methods: {
    test(){
      console.log("Test")
    },
    reset() {
      console.log("Reset")
      let username = this.username;


      if (username != "") {
        let hash = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);


        userService.resetUserPassword(username, hash).then(response => {
          this.submitted = true;
          EmailService.sendResetMail(response.data, hash, username);

        })
        .catch(error => {
                  console.log("There was an error:", error.response);
         });

      }
    }

  }
};
</script>

<style scoped>

</style>
